import { useEffect } from "react"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import AemGrid from "@/components/AemGrid"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import { footerUrl, headerUrl, pageNotFoundDataUrl } from "@/constants"
import { aemAxiosInstance } from "@/constants/api"
import { filterBackEndJson, getDataLayerObj } from "@/utils/helper"

/**
 *
 * @return {JSX.Element}
 */
const Custom404 = ({ data, header, footer, analyticsData = {} }) => {
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])
  return (
    <>
      {header ? <GlobalPageHeader header={header} /> : null}
      {data ? <AemGrid data={data} /> : <h3>404 - Page Not Found</h3>}
      {footer ? <GlobalPageFooter footer={footer} /> : null}
    </>
  )
}

/**
 *
 * @return {Object}
 */
export async function getStaticProps({ locale }) {
  const {
    data: {
      pageComponentProperties: pageData = {},
      headerExpFrg = "",
      footerExpFrg = "",
      data: analyticsData = {},
    } = {},
  } = await aemAxiosInstance({
    url: pageNotFoundDataUrl,
    method: "GET",
  })

  const { data: headerData } = await aemAxiosInstance({
    url: `${headerExpFrg ? headerExpFrg : headerUrl}.model.json`,
    method: "GET",
  })

  const { data: footerData } = await aemAxiosInstance({
    url: `${footerExpFrg ? footerExpFrg : footerUrl}.model.json`,
    method: "GET",
  })

  let data
  if (pageData) data = filterBackEndJson(pageData)
  let header
  if (headerData) header = filterBackEndJson(headerData)
  let footer
  if (footerData) footer = filterBackEndJson(footerData)
  // Pass data to the page via props
  return {
    props: {
      data,
      header,
      footer,
      analyticsData,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default Custom404
